import type { AuthUser } from "../lib/api";
import { homePathForUser } from "./AuthContext";

/**
 * Organizador que también juega (Eduardo 2026-10-04: «¿Qué pasa si un admin
 * también es jugador?»). Al entrar elige «Como organizador» o «Como jugador»
 * y el encabezado le ofrece cambiar de modo. Las cuentas de un solo lado no
 * ven nada de esto.
 */

export type AccountMode = "staff" | "player";

export const CHOOSE_MODE_PATH = "/entrar";

const MODE_STORAGE_KEY = "torneos123-modo-de-entrada";

function isStaffAccount(user: AuthUser): boolean {
  return user.roles.some((role) => role === "superadmin" || role === "admin" || role === "club");
}

/** ¿Puede ir al lado jugador? Lo decide tener un perfil, no el rol (el
 * servidor manda `has_player_profile`; si faltara, se usa el rol). */
export function canPlayAsAccount(user: AuthUser): boolean {
  return user.has_player_profile ?? user.roles.includes("player");
}

export function canChooseAccountMode(user: AuthUser | null | undefined): user is AuthUser {
  return !!user && isStaffAccount(user) && canPlayAsAccount(user);
}

/** Cómo se llama el lado de gestión para esta cuenta. */
export function staffModeLabel(user: AuthUser): string {
  return user.roles.includes("superadmin") ? "administrador" : "organizador";
}

export function readPreferredMode(): AccountMode | null {
  try {
    const value = window.localStorage.getItem(MODE_STORAGE_KEY);
    return value === "staff" || value === "player" ? value : null;
  } catch {
    return null;
  }
}

export function writePreferredMode(mode: AccountMode): void {
  try {
    window.localStorage.setItem(MODE_STORAGE_KEY, mode);
  } catch {
    // Sin almacenamiento (modo privado): la elección solo vale para esta vez.
  }
}

export function homePathForMode(user: AuthUser, mode: AccountMode): string {
  return mode === "player" ? "/player" : homePathForUser(user);
}

/** A dónde va alguien que acaba de entrar: la liga que traía (`next`) manda;
 * si no, la cuenta de dos lados elige y la de un lado va a su inicio. */
export function postLoginPath(user: AuthUser, nextPath: string | null): string {
  if (nextPath) return nextPath;
  return canChooseAccountMode(user) ? CHOOSE_MODE_PATH : homePathForUser(user);
}
